import * as React from "react"
import { PropsWithChildren } from "react"

import { Partners, PartnersContainer, PartnerImage } from "./styles"

import { usePartnerImages } from "../../../hooks/use-partner-images"

export interface PartnerConfig {
  image: string;
}

export default function PartnersComponent(_: PropsWithChildren<PartnerConfig[]>) {
  const partnerImages = usePartnerImages();

  const partners = partnerImages.map(partnerImage => <PartnerImage srcSet={partnerImage.srcSet} alt={partnerImage.alt}/>);

  return (
    <Partners>
      <PartnersContainer>
        {partners}
      </PartnersContainer>
    </Partners>
  )
}
